import type { INotification } from '../api/types';

export const NOTIFICATION_SOCKET_CLIENT_EVENT = {
  Subscribe: 'notifications:subscribe',
  Unsubscribe: 'notifications:unsubscribe',
} as const;

export const NOTIFICATION_SOCKET_EVENT = {
  UnreadCount: 'notifications:unread-count',
  New: 'notifications:new',
} as const;

export type NotificationSocketEventName =
  (typeof NOTIFICATION_SOCKET_EVENT)[keyof typeof NOTIFICATION_SOCKET_EVENT];

export interface NotificationSocketUnreadCountPayload {
  count: number;
}

export type NotificationSocketNewPayload = INotification;

export interface NotificationSocketEventEnvelope<TPayload> {
  event: NotificationSocketEventName;
  timestamp: string;
  payload: TPayload;
}

export interface NotificationSocketServerEventMap {
  [NOTIFICATION_SOCKET_EVENT.UnreadCount]: NotificationSocketUnreadCountPayload;
  [NOTIFICATION_SOCKET_EVENT.New]: NotificationSocketNewPayload;
}

export type NotificationSocketServerEventName = keyof NotificationSocketServerEventMap;

export type NotificationSocketServerEnvelope<
  E extends NotificationSocketServerEventName = NotificationSocketServerEventName,
> = NotificationSocketEventEnvelope<NotificationSocketServerEventMap[E]> & { event: E };

export const isNotificationSocketEvent = <E extends NotificationSocketServerEventName>(
  envelope: { event: NotificationSocketEventName },
  event: E,
): envelope is NotificationSocketServerEnvelope<E> => envelope.event === event;

export const resolveNotificationSocketPayload = <T>(data: unknown): T | null => {
  if (!data || typeof data !== 'object') return null;

  if ('payload' in data && data.payload && typeof data.payload === 'object') {
    return data.payload as T;
  }

  return data as T;
};
